(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Vizceral", [], factory);
	else if(typeof exports === 'object')
		exports["Vizceral"] = factory();
	else
		root["Vizceral"] = factory();
})(window, function() {
return 